export const stripHtmlFromString = (slug) => {
    if (typeof slug !== 'string') {
        return '';
    }
    // preserving line breaks
    return slug.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, '\n').replace(/(<([^>]+)>)/gi, '');
};
